module.exports = __webpack_public_path__ + "static-v-shop/1773936274955/img/logo_master.c8bdcd8d.svg";